export default __webpack_public_path__ + "static/media/prescriptions.72394e93.png";